
<a class="btn" :href="link" role="button">
  <i :class="fa"></i>
  {{ title }}
</a>
